import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./home.css";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";
import Reveal from "./Components/Reveal/Reveal";
import { images } from "./config/imagePaths";

function TestimonialCard({ preview, full, name, company }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <blockquote className="testimonial-card" onClick={() => setIsOpen(!isOpen)}>
      <div className="testimonial-body">
        <p className="testimonial-preview">{preview}</p>
        {!isOpen && <span className="testimonial-read-more">Read more</span>}
        {isOpen && <p className="testimonial-full">{full}</p>}
      </div>
      <footer>
        <strong>{name}</strong>
        <span>{company}</span>
      </footer>
    </blockquote>
  );
}

export default function Home() {
  return (
    <div className="app-container">
      <Navbar />

      <section className="home-banner" aria-label="Banner">
        <img
          src={images.home.banner}
          alt=""
          className="banner-background"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
        <div className="banner-overlay" />
        <div className="banner-content hero-enter">
          <img
            src={images.branding.logo}
            alt="Ignite Logo"
            className="banner-logo"
            loading="eager"
            decoding="async"
          />
          <h1>Ignite Events</h1>
          <p className="banner-tagline">
            Corporate events that are seamless, engaging, and professionally executed.
          </p>
          <Link to="/why-choose" className="banner-cta">Why Choose Us</Link>
        </div>
      </section>

      <main className="main-content">
        <Reveal as="section" className="home-intro-section">
          <p className="home-intro">
            Ignite Events takes the pressure off HR teams and senior leaders by
            delivering corporate events that are seamless, engaging, and
            professionally executed from start to finish. We understand the
            expectations, the brand considerations, and the internal pressures
            that come with organising company-wide experiences. With a blend of
            creativity, reliability, and proven expertise, Ignite ensures your
            event reflects well on your organisation, strengthens team culture,
            and frees you to focus on your people, not the logistics. When you
            choose Ignite, you're choosing peace of mind, polished delivery, and
            an experience your team will genuinely remember.
          </p>
        </Reveal>

        <section className="home-testimonials">
          <Reveal as="h2">What Our Clients Say</Reveal>
          <div className="testimonials-grid">
            <Reveal><TestimonialCard preview={'"Their attention to detail and management of deadlines was matched with a genuine enthusiasm..."'} full="They drew up a detailed itinerary of events at our stand in order to best communicate what we do through various means. It ensured an engaging and interactive presence from us from start to finish. I would highly recommend the team." name="Sarah McClean" company="Future Events" /></Reveal>
            <Reveal delay={100}><TestimonialCard preview={'"Portlaoise Jazz Festival employed Ignite to assist with planning and deployment of the return of the festival..."'} full="From the very outset we developed a strong trust in the capabilities of Ignite events management. The team clearly understood what was required and brought many excellent ideas to the table. They were with us every step of the way and ensured the launch was extremely successful." name="John" company="Portlaoise Jazz Festival" /></Reveal>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
